import React from "react";
import Description from "@mui/icons-material/Description";
import ThumbUp from "@mui/icons-material/ThumbUp";
import Calculate from "@mui/icons-material/Calculate";
import AutoAwesome from "@mui/icons-material/AutoAwesome";
import SupervisorAccount from "@mui/icons-material/SupervisorAccount";
import Storage from "@mui/icons-material/Storage";
import Settings from "@mui/icons-material/Settings";
import Archive from "@mui/icons-material/Archive";
import InsertChart from "@mui/icons-material/InsertChart";
import History from "@mui/icons-material/History";
import People from "@mui/icons-material/People";
import Gavel from "@mui/icons-material/Gavel";
import Shield from "@mui/icons-material/Shield";
import MonetizationOn from "@mui/icons-material/MonetizationOn";
import Category from "@mui/icons-material/Category";
import VerifiedUser from "@mui/icons-material/VerifiedUser";
import AccountBalance from "@mui/icons-material/AccountBalance";
import LocationOn from "@mui/icons-material/LocationOn";
import SupportAgent from "@mui/icons-material/SupportAgent";
import ContactSupport from "@mui/icons-material/ContactSupport";
import Campaign from "@mui/icons-material/Campaign";
import Badge from "@mui/icons-material/Badge";
import Business from "@mui/icons-material/Business";
import PostAdd from "@mui/icons-material/PostAdd";
import Cancel from "@mui/icons-material/Cancel";
import Edit from "@mui/icons-material/Edit";
import Visibility from "@mui/icons-material/Visibility";
import AssignmentTurnedIn from "@mui/icons-material/AssignmentTurnedIn";
import AdminPanelSettings from "@mui/icons-material/AdminPanelSettings";
import DeleteOutline from "@mui/icons-material/DeleteOutline";
import School from "@mui/icons-material/School";
import Lightbulb from "@mui/icons-material/Lightbulb";

const PG_ICON_BY_KEY = {
  description: Description,
  thumbUp: ThumbUp,
  descriptionSecondary: Description,
  calculate: Calculate,
  autoAwesome: AutoAwesome,
};

const LF_ICON_BY_KEY = {
  postAdd: PostAdd,
  cancel: Cancel,
  edit: Edit,
  visibility: Visibility,
  calculate: Calculate,
  autoAwesome: AutoAwesome,
  business: Business,
};

const IU_ICON_BY_KEY = {
  ...PG_ICON_BY_KEY,
  assignmentTurnedIn: AssignmentTurnedIn,
  adminPanelSettings: AdminPanelSettings,
  deleteOutline: DeleteOutline,
  school: School,
  lightbulb: Lightbulb,
  supervisorAccount: SupervisorAccount,
  storage: Storage,
  settings: Settings,
  archive: Archive,
  insertChart: InsertChart,
  history: History,
  people: People,
  gavel: Gavel,
  shield: Shield,
  monetizationOn: MonetizationOn,
  category: Category,
  verifiedUser: VerifiedUser,
  accountBalance: AccountBalance,
  locationOn: LocationOn,
  supportAgent: SupportAgent,
  contactSupport: ContactSupport,
  campaign: Campaign,
  badge: Badge,
  business: Business,
};

function mapEntryIcons(entry, iconByKey, largeMenuIcons = false) {
  const Cmp = iconByKey[entry.iconKey] || Description;
  const iconSize = largeMenuIcons ? "large" : undefined;
  const mapped = {
    ...entry,
    icon: <Cmp fontSize={iconSize} />,
  };
  if (Array.isArray(entry.options)) {
    mapped.options = entry.options.map((opt) => mapEntryIcons(opt, iconByKey, true));
  }
  return mapped;
}

/** Map `iconKey` fields to MUI icon elements for PG dashboard links. */
export function mapPgDashboardLinkIcons(linkGroups) {
  return linkGroups.map((group) => ({
    ...group,
    values: group.values.map((entry) => mapEntryIcons(entry, PG_ICON_BY_KEY)),
  }));
}

/** Map `iconKey` fields to MUI icon elements for internal-user dashboard links. */
export function mapInternalUserDashboardLinkIcons(linkGroups) {
  return linkGroups.map((group) => ({
    ...group,
    values: group.values.map((entry) => mapEntryIcons(entry, IU_ICON_BY_KEY)),
  }));
}

/** Map `iconKey` fields to MUI icon elements for law-firm dashboard links. */
export function mapLawFirmDashboardLinkIcons(linkGroups) {
  return linkGroups.map((group) => ({
    ...group,
    values: group.values.map((entry) => mapEntryIcons(entry, LF_ICON_BY_KEY)),
  }));
}
